import { lazy } from 'react';
import { RouteObject } from 'react-router';

const Pivot = lazy(() => import('../../../modules/reporting/pivot/').then((module) => ({ default: module.Local })));

export default {
  path: 'pivot',
  element: <Pivot />,
} as RouteObject;
